export const TYPE_COMPANY = [
  {
    value: 'limited_company',
    label_en: 'Limited Company',
    label: 'บริษัทจำกัด',
  },
  {
    value: 'public_limited_company',
    label_en: 'Public Limited Company',
    label: 'บริษัทมหาชนจำกัด',
  },
  {
    value: 'limited_partnership',
    label_en: 'Partnership',
    label: 'ห้างหุ้นส่วนจำกัด',
  },
  {
    value: 'other',
    label_en: 'Others',
    label: 'อื่นๆ',
  },
];

export const PREFIX = [
  {
    value: 'Mr.',
    label_en: 'Mr.',
    label: 'นาย',
    patterns: ['mr.', 'นาย'],
  },
  {
    value: 'Mrs.',
    label_en: 'Mrs.',
    label: 'นาง',
    patterns: ['mrs.', 'นาง'],
  },
  {
    value: 'Ms.',
    label_en: 'Ms.',
    label: 'นางสาว',
    patterns: ['ms.', 'นางสาว', 'น.ส.'],
  },
  {
    value: 'other',
    label_en: 'Others',
    label: 'อื่นๆ',
    patterns: [],
  },
];

export const JOB_LIST = [
  {
    value: 'business',
    label_en: 'Business Owner/Self-employed',
    label: 'เจ้าของธุรกิจ/ประกอบอาชีพอิสระ',
  },
  {
    value: 'freelancer',
    label_en: 'Freelancer/Consultant',
    label: 'ฟรีแลนซ์/ที่ปรึกษา',
  },
  {
    value: 'government',
    label_en: 'Government',
    label: 'งานราชการ/รัฐวิสาหกิจ',
  },
  {
    value: 'part_time',
    label_en: 'Part-time/Casual',
    label: 'พนักงานพาร์ทไทม์',
  },
  {
    value: 'professional',
    label_en: 'Professional',
    label: 'พนักงานบริษัทเอกชน',
  },
  {
    value: 'retiree',
    label_en: 'Retiree',
    label: 'เกษียณอายุ',
  },
  {
    value: 'student',
    label_en: 'Student',
    label: 'นักเรียน',
  },
  {
    value: 'other',
    label_en: 'Others (please specify)',
    label: 'อื่นๆ (โปรดระบุ)',
  },
  {
    value: 'undisclosed',
    label_en: 'Undisclosed',
    label: 'ไม่เปิดเผย',
  },
];

export const NUMBEROFRESIDENT_LIST = [
  {
    value: 'one',
    label_en: '1 Person',
    label: '1 ท่าน',
  },
  {
    value: 'two',
    label_en: '2 Person',
    label: '2 ท่าน',
  },
  {
    value: 'more_than_two',
    label_en: 'More than 2',
    label: 'มากกว่า 2 ท่าน',
  },
];

// ยินยอมให้บริษัท โชติฯ เป็นผู้ดำเนินการหักภาษี ณ ที่จ่ายแทน.
// Values are the codes stored on the model (people.WithholdingTaxAgentChoices);
// leaving the dropdown empty sends null, which is a valid "not answered".
export const WITHHOLDING_TAX_AGENT_LIST = [
  {
    value: 'P',
    label_en: 'Yes',
    label: 'ใช่',
  },
  {
    value: 'R',
    label_en: 'No',
    label: 'ไม่',
  },
  {
    value: 'D',
    label_en: 'Deciding',
    label: 'อยู่ในระหว่างตัดสินใจ',
  },
];

// Preselected in the add-customer form. The model default stays null: this is a
// UI convenience, not a value the backend assumes.
export const WITHHOLDING_TAX_AGENT_DEFAULT = 'P';

const SHORT_VIDEO_LABEL = 'คลิปวีดีโอสั้น (TikTok / Reels / Shorts)';
const FACEBOOK_LABEL = 'Facebook';
const GOOGLE_LABEL = 'Google Search';
const LINE_OA_LABEL = 'Line OA';
const PROPERTY_WEBSITE_LABEL =
  'เว็บไซต์อสังหาริมทรัพย์ (Rent Hub, DDProperty ฯลฯ)';
const FRIEND_LABEL = 'การบอกต่อจากเพื่อน / คนรู้จัก';
const BILLBOARD_LABEL = 'ป้ายโฆษณา / ผ่านหน้าโครงการ';

export const CHANNEL_LIST = [
  {
    value: 'short_video',
    label_en: SHORT_VIDEO_LABEL,
    label: SHORT_VIDEO_LABEL,
  },
  {
    value: 'facebook',
    label_en: FACEBOOK_LABEL,
    label: FACEBOOK_LABEL,
  },
  {
    value: 'google',
    label_en: GOOGLE_LABEL,
    label: GOOGLE_LABEL,
  },
  {
    value: 'line_oa',
    label_en: LINE_OA_LABEL,
    label: LINE_OA_LABEL,
  },
  {
    value: 'property_website',
    label_en: PROPERTY_WEBSITE_LABEL,
    label: PROPERTY_WEBSITE_LABEL,
  },
  {
    value: 'friend',
    label_en: FRIEND_LABEL,
    label: FRIEND_LABEL,
  },
  {
    value: 'billboard',
    label_en: BILLBOARD_LABEL,
    label: BILLBOARD_LABEL,
  },
  {
    value: 'other',
    label_en: 'Others',
    label: 'อื่นๆ',
  },
];

export const FULL_DATE = [
  { th: 'มกราคม', en: 'January', short: '01' },
  { th: 'กุมภาพันธ์', en: 'February', short: '02' },
  { th: 'มีนาคม', en: 'March', short: '03' },
  { th: 'เมษายน', en: 'April', short: '04' },
  { th: 'พฤษภาคม', en: 'May', short: '05' },
  { th: 'มิถุนายน', en: 'June', short: '06' },
  { th: 'กรกฎาคม', en: 'July', short: '07' },
  { th: 'สิงหาคม', en: 'August', short: '08' },
  { th: 'กันยายน', en: 'September', short: '09' },
  { th: 'ตุลาคม', en: 'October', short: '10' },
  { th: 'พฤศจิกายน', en: 'November', short: '11' },
  { th: 'ธันวาคม', en: 'December', short: '12' },
];

export const ADDRESS_FIELDS = [
  'house_no',
  'village_no',
  'road',
  'province',
  'district',
  'sub_district',
  'postal_code',
];

/** Flat info (`house_no`, `contact_house_no`, ...) -> address group value. */
export function addressFromInfo(
  info: Record<string, any>,
  prefix = '',
): Record<string, any> {
  return ADDRESS_FIELDS.reduce(
    (address, field) => ({
      ...address,
      [field]: info?.[prefix + field] ?? null,
    }),
    {},
  );
}

/** Address group value -> flat info keys (blank text, null ids). */
export function addressToInfo(
  address: Record<string, any>,
  prefix = '',
): Record<string, any> {
  return ADDRESS_FIELDS.reduce(
    (info, field) => ({
      ...info,
      [prefix + field]: address?.[field] ?? null,
    }),
    {},
  );
}

/**
 * Validation errors of the update-profile API come back as
 * `{ "<individual|company>_info": { "<field>": ["..."] } }`, other errors as
 * `{ "detail": "..." }`. Returns one readable message.
 */
export function updateProfileErrorMessage(error: any): string {
  const body = error?.error;
  if (!body || typeof body === 'string') {
    return body || 'Unable to submit the request';
  }
  if (body.detail) {
    return body.detail;
  }
  const messages: string[] = [];
  const collect = (value: any, key?: string): void => {
    if (Array.isArray(value)) {
      value.forEach((item) => collect(item, key));
    } else if (value && typeof value === 'object') {
      Object.keys(value).forEach((k) => collect(value[k], k));
    } else if (value) {
      messages.push(key ? `${key}: ${value}` : `${value}`);
    }
  };
  collect(body);
  return messages.join('\n') || 'Unable to submit the request';
}
